import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import axios, {AxiosError} from 'axios';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {QUERY_KEYS} from '../../utils/queryKeys';
import {type TypedTranslation} from '../../i18n';
import {IPresentation} from '../../incase-domain/presentation';
import {startPresCreateSpinnerAction, stopPresCreateSpinnerAction} from '../../store/actions/spinner';
import {createPresentation} from '../presentation';

export const CREATE_PRESENTATION_KEY = ['createPresentation'];

function useCreatePresentation(): UseMutationResult<
    IPresentation,
    unknown,
    | {
          name?: string;
          empty?: boolean;
      }
    | undefined,
    void
> {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const {t} = useTranslation();

    return useMutation((args?: {name?: string; empty?: boolean}) => createPresentation(args?.name, args?.empty), {
        mutationKey: CREATE_PRESENTATION_KEY,
        onMutate: () => {
            dispatch(startPresCreateSpinnerAction());
        },
        onSettled: () => {
            dispatch(stopPresCreateSpinnerAction());
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: QUERY_KEYS.presentation.lists()});
        },
        onError: (error) => {
            if (axios.isAxiosError(error)) {
                const errorData = (error as AxiosError<{message: string; error: string}>).response?.data;

                if (errorData) {
                    toast.error(t(errorData.message as TypedTranslation));
                }
            }
        },
    });
}

export default useCreatePresentation;
